<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(text v-on="on") {{ buttonText }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ translations.title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container(fluid).text-center
          v-row.pa-10(justify="center")
            v-col(cols="4")
              i Nombre:
              b Test
            v-col(cols="4")
              i Clave:
              b ABC123
</template>

<script>
  export default {
    name: "ProviderInfoDialog",
    props: {
      buttonText: {
        type: String,
        default: 'See competition'
      },
    },
    data:() => ({
      dialog: false,
      items: [
        {
          text:'Operator 34',
          value:1
        },
        {
          text:'Operator 83798',
          value:2
        },
        {
          text:'Operator 94309',
          value:3
        }
      ]
    }),
    computed:{
      translations() {
        return this.$t("components.providerInfoDialog");
      },
    },
  }
</script>

<style lang="sass">
</style>